import React from 'react';
import logo from '../assets/img/whatsapp (1).png';

function Contact({t,language}) {
    const handleWhatsAppClick = (number) => {
        window.open(`https://wa.me/${number}?`, '_blank');
    };
    const isRTL = language === 'ar' || language === 'ku';

    return (
        <div className='bg-[#6A9C89] pb-2 pt-2'>
            <div className={`text-${isRTL ? 'end' : 'start'} flex flex-col md:flex-row md:justify-between items-stretch m-5 md:m-20 h-full`}>
                <div className="bg-[#c4dad28f] p-3 rounded-lg flex flex-col justify-around w-full mb-8 md:mr-5 flex-grow">
                    <h1 className="text-xl font-semibold mb-4 ">{t('whatsappContact')}</h1>
                    <div className="flex flex-col md:flex-row md:space-x-4 w-full">
                        <div className='flex flex-col w-full'>
                            <label className="text-lg mb-2 w-full">{t('korek')}</label>
                            <div 
                                className="flex items-center p-2 rounded w-full text-white bg-[#16423ccc] shadow-lg hover:bg-[#13413a] cursor-pointer"
                                onClick={() => handleWhatsAppClick('9647511571330')}
                            >
                                <img src={logo} alt="WhatsApp logo" className="w-5 mr-2 md:mr-4" />
                                <h1 className="text-sm md:text-base">+964 751 157 1330</h1>
                            </div>
                        </div>
                        <div className='flex flex-col w-full'>
                            <label className="text-lg mb-2 w-full">{t('zain')}</label>
                            <div 
                                className="flex items-center p-2 rounded w-full text-white bg-[#16423ccc] shadow-lg hover:bg-[#13413a] cursor-pointer"
                                onClick={() => handleWhatsAppClick('9647821611444')}
                            >
                                <img src={logo} alt="WhatsApp logo" className="w-5 mr-2 md:mr-4" />
                                <h1 className="text-sm md:text-base">+964 782 161 1444</h1>
                            </div>
                        </div>
                    </div>
                    <h1 className="text-xl font-semibold m-4 mb-3">{t('location')}</h1>
                    <div
                        className="w-full h-64 cursor-pointer mb-2"
                        onClick={() => window.open('https://www.google.com/maps/search/?api=1&query=Erbil', '_blank')}
                    >
                        <iframe
                            title="Google Map of Erbil"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.2544310884165!2d43.993118715276!3d36.19122917998517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1519314af2cc80bb%3A0xfaf392062f99e64!2sErbil%2C%20Iraq!5e0!3m2!1sen!2sus!4v1632275489136!5m2!1sen!2sus"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>

                <div className="w-full bg-[#c4dad28f] p-3 rounded-lg flex-grow h-full flex flex-col justify-between">
                    <h2 className="text-xl font-semibold mb-4">{t('sendMessage')}</h2>
                    <form className="flex flex-col space-y-4">
                        <div className="flex flex-col md:flex-row md:space-x-4 w-full">
                            <div className="flex flex-col w-full">
                                <label className="text-lg mb-2">{t('name')}</label>
                                <input
                                    type="text"
                                    className="border p-2 rounded w-full"
                                    placeholder="Enter your name"
                                    required
                                />
                            </div>
                            <div className="flex flex-col w-full">
                                <label className="text-lg mb-2">{t('email')}</label>
                                <input
                                    type="email"
                                    className="border p-2 rounded"
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex flex-col ">
                            <label className="text-lg mb-2">{t('Message')}</label>
                            <textarea
                                className="border p-2 rounded"
                                placeholder="Enter your message"
                                rows={8}
                                required
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="bg-[#16423ccc] text-white p-2 rounded hover:bg-[#13413a]"
                        >
                            {t('submit')}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;
